var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRenault(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.94 19.808l-4.422-6.73 2.341-5.611-8.048 12.266 5.158 7.216 4.97-7.141zm-4.934-5.333l3.963 5.637-3.963 5.765-4.133-5.754 4.133-5.648z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.864 33.6l.14.224h6.298l.133-.23 8.181-13.471.15-.246-.15-.24L23.5 6.4l-.139-.219h-6.655l-.14.224-8 13.254-.149.24.15.24L16.864 33.6zm.363-26.507h5.61l7.84 12.8h-4.943l-7.067 10.224.95-2.293-5.574-7.925H9.521v-.027l7.706-12.779z"
  })));
}
export default SvgRenault;